export default __webpack_public_path__ + "static/wav-1000-7f378c0b0e055083f59ed0c0eccc8959.png";